<app-matter-url-pdf-viewer
	*ngIf="googleSrcUrl || url || base64Encoded || blob"
	[googleSrcUrl]="googleSrcUrl"
	[base64Encoded]="base64Encoded"
	[content]="url || blob"
	[fileName]="fileName"
	[fileType]="fileType"
	class="h-full"
	[showDelete]="fileId && showDelete"
	(delete)="delete()"
	(closeModal)="close()"
/>
